import { Badge } from "../components/ui/badge";
import axios from "axios";
import { clsx } from "clsx"
import { CheckCircle, Clock, Clock11, RefreshCw, XCircle } from "lucide-react";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function isScheduled(dateNum1, dateNum2) {
  const d1 = new Date(dateNum1);
  const d2 = new Date(dateNum2);

  return !(
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export function getTimeRemaining(scheduledDate, scheduledTime) {
  // scheduledTime: { hour, minute, period: 'AM'|'PM' }
  const { hour, minute, period } = scheduledTime;

  // Convert hour to 24h format
  let hour24 = hour % 12;
  if (period.toUpperCase() === 'PM') hour24 += 12;

  // Create Date object for scheduled datetime
  const scheduled = new Date(scheduledDate);
  scheduled.setHours(hour24, minute, 0, 0);

  // Subtract 12 hours
  const schedulingTime = new Date(scheduled.getTime() - 12 * 60 * 60 * 1000);

  // Current time
  const now = new Date();

  // Calculate difference in milliseconds
  let diff = schedulingTime - now;

  if (diff <= 0) {
    // Time passed
    return { days: 0, hours: 0, minutes: 0 };
  }

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  diff -= days * (1000 * 60 * 60 * 24);

  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * (1000 * 60 * 60);

  const minutes = Math.floor(diff / (1000 * 60));

  return { days, hours, minutes };
}
const addressCache = {};

// helper to normalize coordinates (4 decimal places)
const normalizeCoords = (lat, lng) => {
  return `${lat.toFixed(4)},${lng.toFixed(4)}`;
};

export const fetchAddress = async (latitude, longitude) => {
  if (latitude == null || longitude == null) {
    return "Invalid coordinates";
  }

  const cacheKey = normalizeCoords(latitude, longitude);

  // return cached value if present
  if (addressCache[cacheKey]) {
    return addressCache[cacheKey];
  }

  const apiKey = "AIzaSyDJQNAbTK3AGLlmRGVxa3VbejegSp-qB9A";
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${cacheKey}&key=${apiKey}`;

  try {
    const response = await axios.get(url);
    const data = response.data;

    const address =
      data.results && data.results.length > 0
        ? data.results[0].formatted_address
        : "Address not found";

    // cache result (even negative ones to avoid repeated calls)
    addressCache[cacheKey] = address;

    return address;
  } catch (error) {
    console.error("Error fetching address:", error);

    const fallback = "Error fetching address";
    addressCache[cacheKey] = fallback; // optional
    return fallback;
  }
};

export const formatPayment = (num, options = {}) => {
  const {
    is80 = true,
    isVolunteer = false,
    isShoveller= false
  } = options;

  let amount = num / 100;

  if (!isVolunteer && is80) {
    amount *= 0.8;
  }
  
  if (isVolunteer && isShoveller) {
    return 'Volunteer'
  }

  return `${amount.toFixed(2)}`;
};

export const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

export const formatScheduledDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
};

  export const formatTime = (scheduledTime) => {
    if (!scheduledTime) return 'Not scheduled';
    return `${scheduledTime.hour || '00'}:${scheduledTime.minute || '00'} ${scheduledTime.period || 'AM'}`;
  };

  export const getStatusIcon = (status) => {
    switch (status) {
      case 'scheduled':
        return <Clock11 className="w-4 h-4 text-pink-600" />;
      case 'completed':
        return <CheckCircle className="w-4 h-4 text-green-600" />;
      case 'in-progress':
        return <RefreshCw className="w-4 h-4 text-blue-600" />;
      case 'not-anymore':
        return <XCircle className="w-4 h-4 text-red-600" />;
      default:
        return <Clock className="w-4 h-4 text-yellow-600" />;
    }
  };

  export const getStatusBadge = (status) => {
    const variants = {
      'completed': { color: 'bg-green-100 text-green-800', text: 'Completed' },
      'in-progress': { color: 'bg-blue-100 text-blue-800', text: 'In Progress' },
      'not-anymore': { color: 'bg-red-100 text-red-800', text: 'Cancelled' },
      'scheduled': { color: 'bg-pink-100 text-pink-800', text: 'Scheduled Posting' },
      'open': { color: 'bg-yellow-100 text-yellow-800', text: 'Open' },
    };
    
    const variant = variants[status] || { color: 'bg-gray-100 text-gray-800', text: 'Unknown' };
    
    return (
      <Badge className={`${variant.color} hover:bg-`}>
        {variant.text}
      </Badge>
    );
  };